import React from 'react';
import { MultiSelectDragIconGrey } from '../../../../../../assets/hostedassets';

export const PinnedColumnIcon: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M4 7C4 6.44772 4.44772 6 5 6H11C11.5523 6 12 6.44772 12 7V8C12 8.55228 11.5523 9 11 9H5C4.44772 9 4 8.55228 4 8V7Z"
            fill="#ccc"
        />
        <path d="M8 2V14" stroke="#ccc" strokeWidth="1" strokeLinecap="round" />
    </svg>
);

export const DragHandleIcon: React.FC = () => (
    <img src={MultiSelectDragIconGrey} alt="Drag handle" width="16" height="16" draggable={false} />
);

export const MoveToTopIcon: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M8 2L2 8H6V14H10V8H14L8 2Z" fill="#666" stroke="#666" strokeWidth="1" strokeLinejoin="round" />
    </svg>
);

export const CrossIcon: React.FC = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M12 4L4 12M4 4L12 12" stroke="#999" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
